import * as mod_i18n from "./i18n";
import { getConfig } from "./config";
export function createSupportContext() {
    const now = new Date();
    const recentRequest = getRecentRequestHistoryEntry();
    const recentRequestRef = getSupportRefForRequest(recentRequest);
    const recentFailedRequest = getRecentFailedRequestHistoryEntry();
    const recentFailedRequestRef = getSupportRefForRequest(recentFailedRequest);
    return {
        time: now,
        recentRequestRef: recentRequestRef,
        recentFailedRequestRef: recentFailedRequestRef,
    };
}
export function createSupportMailTo() {
    const supportContext = createSupportContext();
    return createSupportMailToForContext(supportContext);
}
export function createSupportMailToForContext(supportContext) {
    const refTimestamp = getSupportRefForTimestamp(supportContext.time);
    const refShort = getSupportRefShort(refTimestamp, supportContext.recentRequestRef, supportContext.recentFailedRequestRef);
    const refLong = getSupportRefLong(refTimestamp, supportContext.recentRequestRef, supportContext.recentFailedRequestRef);
    const appTitle = getAppTitle();
    const subject = mod_i18n.i18next.t("support.mailto.subject", {
        appName: appTitle,
        ref: refShort,
    });
    const body = mod_i18n.i18next.t("support.mailto.body", {
        appName: appTitle,
        ref: refLong,
    });
    const eMailTo = getEMailTo();
    return mod_i18n.i18next.t("support.mailto.base", {
        eMailTo: encodeURIComponent(eMailTo),
        subject: encodeURIComponent(subject),
        body: encodeURIComponent(body),
    });
}
function hasRequestHistory() {
    return ("zebInsightsRequestHistory" in window &&
        window.zebInsightsRequestHistory != null);
}
function getRequestHistoryEntries() {
    if ("zebInsightsRequestHistory" in window &&
        window.zebInsightsRequestHistory != null) {
        const entries = window.zebInsightsRequestHistory;
        return entries;
    }
    else {
        return [];
    }
}
function getRecentRequestHistoryEntry() {
    const entries = getRequestHistoryEntries();
    return entries.find((entry) => entry.traceparent != null);
}
function getRecentFailedRequestHistoryEntry() {
    const entries = getRequestHistoryEntries();
    return entries.find((entry) => entry.status >= 400 && entry.traceparent != null);
}
function getSupportRefForTimestamp(time) {
    const year = String(time.getUTCFullYear());
    const month = ("0" + (time.getUTCMonth() + 1)).slice(-2);
    const day = ("0" + time.getUTCDate()).slice(-2);
    const hour = ("0" + time.getUTCHours()).slice(-2);
    const min = ("0" + time.getUTCMinutes()).slice(-2);
    const sec = ("0" + time.getUTCSeconds()).slice(-2);
    return year + month + day + hour + min + sec + "Z";
}
function getSupportRefForRequest(request) {
    const result = request ? request.traceparent : null;
    if (result == null) {
        return null;
    }
    else {
        return result.toLowerCase();
    }
}
function getSupportRefShort(timestamp, tpRecentRequest, tpRecentFailedRequest) {
    let supportRef = "X=" + timestamp;
    if (tpRecentFailedRequest) {
        supportRef = supportRef + ",F=" + tpRecentFailedRequest;
    }
    if (tpRecentRequest) {
        supportRef = supportRef + ",R=" + tpRecentRequest;
    }
    return supportRef;
}
function getSupportRefLong(timestamp, tpRecentRequest, tpRecentFailedRequest) {
    let supportRef = mod_i18n.i18next.t("support.mailto.supportRefLong.time", {
        time: timestamp,
    });
    if (tpRecentFailedRequest) {
        supportRef =
            supportRef +
                mod_i18n.i18next.t("support.mailto.supportRefLong.failedReq", {
                    req: tpRecentFailedRequest,
                });
    }
    if (tpRecentRequest) {
        supportRef =
            supportRef +
                mod_i18n.i18next.t("support.mailto.supportRefLong.recentReq", {
                    req: tpRecentRequest,
                });
    }
    return supportRef;
}
function getAppTitle() {
    const config = getConfig();
    const language = mod_i18n.getDocumentLanguage();
    const defaultLanguage = mod_i18n.getConfigDefaultLanguage();
    let appName = config && config.appName;
    if (appName == null) {
        appName = "zeb digital services";
    }
    return mod_i18n.getFromData(config && config.appNameDisplayable, language, defaultLanguage, appName);
}
function getEMailTo() {
    const config = getConfig();
    let eMailTo = config && config.customerSupport && config.customerSupport.eMailTo;
    if (eMailTo == null) {
        return mod_i18n.i18next.t("support.mailto.defaultEMailTo");
    }
    else {
        return eMailTo;
    }
}
export function registerCompatSupportMailTo() {
    window.zebDshCompatSupportCreateMailTo = createSupportMailTo;
}
